$(document).on('click', '[data-ajax-popup]', function (e) {
    e.preventDefault();
    const item = $(this);
    const isButton = item.is('button[type="submit"], input[type="submit"]');
    const title = item.data('title');
    const method = item.data('method') || 'GET';
    const size = item.data('size') || 'uk-width-large';
    const url = item.attr('href') || item.data('url');
    const modal = $('#commonModal');

    modal.find('.loading').addClass('show');

    const handleResponse = (data) => {
        try {
            data = JSON.parse(data);
        } catch (e) {
            console.error('Ошибка при парсинге JSON:', e);
        }

        const sizes = ['small', 'medium', 'large', 'xlarge', 'auto'];
        const modifiers = ['', '@s', '@m', '@l'];
        const widthClasses = [];

        sizes.forEach(size => {
            modifiers.forEach(mod => {
                widthClasses.push(`uk-width-${size}${mod}`);
            });
        });
        const dialog = document.querySelector('#commonModal [data-type="dialog"]');
        widthClasses.forEach(c => dialog.classList.remove(c));

        modal.find('[data-type="dialog"]').addClass(size);
        modal.find('[data-type="title"]').html(data.title || title);
        modal.find('[data-type="content"]').html(data.content || data);
        if (typeof data.updates !== "undefined") {
            for (let item in data?.updates) {
                const updateItem = document.querySelector(item);
                if (updateItem) {
                    updateItem.innerHTML = data.updates[item];
                }
            }
        }
        UIkit.modal(modal).show();
        modal.find('.loading').removeClass('show');
    };

    const handleError = () => {
        modal.find('[data-type="title"]').html(title);
    };

    if (isButton) {
        const form = item.closest('form');
        if (form.length && url) {
            $.ajax({
                url,
                method: form.attr('method') || 'POST',
                data: form.serialize(),
                headers: {'x-secret': 'true'},
                success: handleResponse,
                error: handleError,
            });
        }
    } else if (url) {
        $.ajax({
            url,
            method,
            headers: {'x-secret': 'true'},
            success: handleResponse,
            error: handleError,
        });
    }

});
/**
 * Send register phone code
 */
$(document).on("click", "#button-get-sms-code", function () {
    let buttonSendRegisterCode = $("html").find("#button-get-sms-code");
    let url = buttonSendRegisterCode.attr("data-url");
    let method = "POST";
    let retryMessage = $(".retry-message");
    let retrySeconds = $(".retry-seconds");
    let seconds = $(".seconds");

    buttonSendRegisterCode.attr('disabled', true);

    $.ajax({
        url,
        method,
        headers: {'x-secret': 'true'},
        data: {
            phone: $('input[name="phone"]').val()
        },
        success: function (data) {
            retryMessage.html(data.retry_message);
            retrySeconds.html(data.retry_seconds);
            seconds.show();
            startCountdown(30);
        },
        error: function () {
            retryMessage.html('');
            retrySeconds.html('');
            seconds.show();
        },
    });

    /**
     * Timer for activating resend register code button
     * @param seconds
     */
    function startCountdown(seconds = 59) {
        let remaining = seconds;
        let $wrapper = $('.verify-sms-code-wrapper');
        let $retrySeconds = $wrapper.find('.retry-seconds');
        let $retryMessage = $wrapper.find('.retry-message');
        let $secondsSuffix = $wrapper.find('.seconds');

        $retryMessage.show();
        $retrySeconds.show();
        $secondsSuffix.show();

        $retrySeconds.text(remaining);

        let interval = setInterval(function () {
            remaining--;
            $retrySeconds.text(remaining + ' s.');

            if (remaining <= 0) {
                clearInterval(interval);

                $retryMessage.text('');
                $retrySeconds.hide();
                $secondsSuffix.hide();
                $('#button-get-sms-code').prop('disabled', false);
            }
        }, 1000);
    }
});
